import React from "react";
import { Helmet } from "react-helmet-async";

/**
 * Renders <title>, meta description/keywords, robots and open-graph tags.
 *
 * Props:
 *   title, description, keywords, image, canonical
 *   robots: "index,follow" | "noindex,nofollow" | "noindex" | "nofollow" | etc.
 *           If omitted, defaults to indexable.
 */
const SeoHead = ({ title, description, keywords, image, canonical, robots }) => {
  const robotsContent = (robots || "index,follow").toString().trim();
  return (
    <Helmet>
      {title ? <title>{title}</title> : null}
      {description ? <meta name="description" content={description} /> : null}
      {keywords ? <meta name="keywords" content={keywords} /> : null}
      <meta name="robots" content={robotsContent} />

      {/* Open Graph (Facebook, LinkedIn, WhatsApp link previews) */}
      {title ? <meta property="og:title" content={title} /> : null}
      {description ? <meta property="og:description" content={description} /> : null}
      {image ? <meta property="og:image" content={image} /> : null}
      <meta property="og:type" content="website" />

      {/* Twitter card */}
      <meta name="twitter:card" content="summary_large_image" />
      {title ? <meta name="twitter:title" content={title} /> : null}
      {description ? <meta name="twitter:description" content={description} /> : null}
      {image ? <meta name="twitter:image" content={image} /> : null}

      {canonical ? <link rel="canonical" href={canonical} /> : null}
    </Helmet>
  );
};

export default SeoHead;
